// @ts-check
import {Component} from 'panel';
import {registerMPElement} from '../../util/register-element';
import {nameToInitials} from '../../util/string';
import Tooltip from '../tooltip';

import template from './index.jade';
import css from './index.styl?inline';

export default registerMPElement(
  `mp-user-icon`,
  class extends Component {
    static get attrsSchema() {
      return {
        ...super.attrsSchema,
        name: `string`,
        'show-tooltip': {type: `boolean`, default: true},
        'tooltip-text': `string`,
        'tooltip-placement': Tooltip.attrsSchema[`placement`],
      };
    }

    get config() {
      return {
        css,
        template,
        useShadowDom: true,
        helpers: {
          nameToInitials,
        },
      };
    }
  },
);
